(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/views/betslip.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/views/betslip.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lotto=_svs.lotto||{};
_svs.lotto.components=_svs.lotto.components||{};
_svs.lotto.components.play=_svs.lotto.components.play||{};
_svs.lotto.components.play.templates=_svs.lotto.components.play.templates||{};
svs.lotto.components.play.templates.betslip = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id='drawDaysRegion'></div>\n<div id='participationRegion'></div>\n<div id='jokerRegion'></div>\n<div id='drawCountRegion'></div>\n<div class='numbergames-footer-section'>\n  <div id='subscriptionInfoRegion'></div>\n  <div id='trissRegion'></div>\n  <div id='accountSelectorRegion'></div>\n</div>\n";
},"useData":true});
Handlebars.partials['svs-lotto-components-play-betslip'] = svs.lotto.components.play.templates.betslip;
})(svs, Handlebars);


 })(window);